import { AxiosResponse } from "axios";
import { DeletePartTypePerPartRequest, PartTypePerPartRequest } from "@/main/models/request";
import { PartTypePerPartResponse } from "@/main/models/response/partTypePerPartResponse";
import { Result } from "../../models/common/resultResponse";
import { api } from "../base/api";
import { IPartTypePerPartApi } from "../base/registration/partTypePerPartApi";

const baseRoute: string = "PartTypePerPart";

export class PartTypePerPartApi extends IPartTypePerPartApi {
	savePartTypePerPart(request: PartTypePerPartRequest): Promise<AxiosResponse<Result<PartTypePerPartResponse>>> {
		return api.post(`${baseRoute}/save`, request);
	}

	deletePartTypePerPart(
		request: DeletePartTypePerPartRequest,
	): Promise<AxiosResponse<Result<PartTypePerPartResponse>>> {
		return api.post(`${baseRoute}/delete`, request);
	}
}
